import styled from 'styled-components';
import { FlexBetween } from '../../../global/commonStyle';

const Main = styled.div`
  max-width: 662px;
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 0.5px solid var(--border-primary);
  background-color: var(--background-primary);
  border-radius: var(--border-radius-6);

  .loading-animation {
    overflow: hidden;
  }

  .loading-animation::before {
    content: '';
    display: block;
    height: 100%;
    width: 100%;
    animation: loading 1s infinite;
    background: linear-gradient(to right, transparent, var(--background-tertiary), transparent);
  }

  @keyframes loading {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
`;

const First = styled.div`
  padding: var(--space-12) var(--space-16);
  ${FlexBetween}
  gap: var(--space-12);
  border-bottom: 0.5px solid var(--border-primary);
  :last-child {
    border-bottom: none;
  }
`;

const Left = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
`;

const Right = styled.div`
  display: flex;
  gap: var(--space-12);
`;

const Top = styled.div`
  background: var(--background-muted);
  border-radius: var(--border-radius-6);
  width: 155px;
  height: 10px;
  margin-block: var(--space-5);
`;

const Bottom = styled.div`
  background: var(--background-muted);
  border-radius: var(--border-radius-6);
  width: 110px;
  height: 8px;
  margin-block: var(--space-6);
`;

const Square = styled.div`
  background: var(--background-muted);
  border-radius: var(--border-radius-4);
  width: 16px;
  height: 16px;
  margin: var(--space-4);
`;
export { Main, First, Left, Right, Top, Bottom, Square };
